import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export default function UserCreate() {
  const navigate = useNavigate();

  return (
    <div className="pp-page iam-page">
      <Result
        status="info"
        title="新建用户功能待接入"
        subTitle="原流程依赖本地临时数据完成用户创建及初始用户组、权限策略授权；真实接口流程接入前暂不提供该操作。"
        extra={
          <Button type="primary" onClick={() => navigate('/iam/users')}>
            返回用户列表
          </Button>
        }
      />
    </div>
  );
}
